var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoading || _vm.hasLoaded || _vm.hasError
    ? _c(
        "div",
        {
          class: [
            "btn-progress",
            ..._vm.variantClassList,
            _vm.isLoading && "is-loading",
            _vm.hasLoaded && "has-loaded",
            _vm.isActionRibbon && "is-action-ribbon",
            _vm.isOutline && "is-outline"
          ]
        },
        [
          _vm.isLoading
            ? _c("span", { staticClass: "btn-progress__loading" }, [_vm._m(0)])
            : _vm._e(),
          _vm.hasLoaded
            ? _c("span", { staticClass: "btn-progress__loaded" }, [
                _c("i", { staticClass: "icon icon-circle-check" })
              ])
            : _vm._e(),
          _vm.hasError
            ? _c(
                "Tooltip",
                {
                  staticClass: "btn-progress__error",
                  attrs: { visible: _vm.hasError, state: "negative" }
                },
                [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "btn-progress__spinner" }, [
      _c("div", { staticClass: "spin" }),
      _c("div", { staticClass: "spin" }),
      _c("div", { staticClass: "spin" }),
      _c("div", { staticClass: "spin" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }